
(() => {
  'use strict';

  const ROOT_ID='otp-nca-account-modal';
  const ACCOUNT_TRIGGER_SELECTOR='[data-nmr-header-account],[data-account-icon],[data-nmr-account-auth-open]';
  const WARM_VERSION='16';
  let frame=0;
  let warmPromise=null;
  let warmAttempts=0;

  const translations=new Map([
    ['name','الاسم'],
    ['full name','الاسم الكامل'],
    ['first name','الاسم الأول'],
    ['last name','اسم العائلة'],
    ['email','البريد الإلكتروني'],
    ['email address','البريد الإلكتروني'],
    ['phone','رقم الهاتف'],
    ['phone number','رقم الهاتف'],
    ['address','العنوان'],
    ['addresses','العناوين'],
    ['my addresses','عناويني'],
    ['account','الحساب'],
    ['my account','حسابي'],
    ['profile','الملف الشخصي'],
    ['profile details','بيانات الملف الشخصي'],
    ['manage your personal information','إدارة معلوماتك الشخصية'],
    ['personal information','المعلومات الشخصية'],
    ['basic information','المعلومات الأساسية'],
    ['orders','الطلبات'],
    ['my orders','طلباتي'],
    ['order history','سجل الطلبات'],
    ['order details','تفاصيل الطلب'],
    ['order','الطلب'],
    ['date','التاريخ'],
    ['total','الإجمالي'],
    ['status','الحالة'],
    ['payment status','حالة الدفع'],
    ['fulfillment status','حالة التنفيذ'],
    ['view order','عرض الطلب'],
    ['no orders yet','لا توجد طلبات حتى الآن'],
    ['loading orders...','جار تحميل الطلبات…'],
    ['loading orders…','جار تحميل الطلبات…'],
    ['loading orders','جار تحميل الطلبات…'],
    ['you have not placed any orders yet','لم تقم بأي طلب حتى الآن'],
    ['you haven\'t placed any orders yet','لم تقم بأي طلب حتى الآن'],
    ['edit','تعديل'],
    ['save','حفظ'],
    ['save changes','حفظ التغييرات'],
    ['update','تحديث'],
    ['update changes','تحديث التغييرات'],
    ['cancel','إلغاء'],
    ['discard','إلغاء'],
    ['discard changes','إلغاء التغييرات'],
    ['delete','حذف'],
    ['default','افتراضي'],
    ['add address','إضافة عنوان'],
    ['add new address','إضافة عنوان جديد'],
    ['edit address','تعديل العنوان'],
    ['update address','تحديث العنوان'],
    ['address line 1','العنوان'],
    ['address line 2','تفاصيل إضافية (اختياري)'],
    ['street address','عنوان الشارع'],
    ['apartment, suite, etc.','الشقة أو الجناح (اختياري)'],
    ['apartment','الشقة'],
    ['suite','الجناح'],
    ['country','الدولة'],
    ['country/region','الدولة / المنطقة'],
    ['country or region','الدولة / المنطقة'],
    ['city','المدينة'],
    ['state','الولاية / المحافظة'],
    ['province','المحافظة'],
    ['state/province','الولاية / المحافظة'],
    ['region','المنطقة'],
    ['postal code','الرمز البريدي'],
    ['postcode','الرمز البريدي'],
    ['zip code','الرمز البريدي'],
    ['log out','تسجيل الخروج'],
    ['logout','تسجيل الخروج']
  ]);

  const roleMap=new Map([
    ['basic information','section'],
    ['المعلومات الأساسية','section'],
    ['first name','field-label'],
    ['الاسم الأول','field-label'],
    ['last name','field-label'],
    ['اسم العائلة','field-label'],
    ['email address','field-label'],
    ['البريد الإلكتروني','field-label'],
    ['phone number','field-label'],
    ['رقم الهاتف','field-label']
  ]);

  const tabDefs=[
    {id:'profile',keys:['profile','الملف الشخصي','my info','my information','معلوماتي'],ar:'معلوماتي',en:'My info'},
    {id:'orders',keys:['my orders','orders','طلباتي','الطلبات'],ar:'طلباتي',en:'My Orders'},
    {id:'addresses',keys:['addresses','my addresses','العناوين','عناويني'],ar:'العناوين',en:'Addresses'}
  ];

  function root(){
    return document.getElementById(ROOT_ID);
  }

  function dashboard(){
    return root()?.querySelector('.otp-account-dashboard')||null;
  }

  function isArabic(){
    const lang=String(document.documentElement.lang||'').toLowerCase();
    return lang.startsWith('ar')||document.documentElement.dir==='rtl';
  }

  function normalize(value){
    return String(value||'').replace(/\s+/g,' ').trim().toLowerCase();
  }

  const loadingPairs=[
    ['loading','جار التحميل…'],
    ['loading...','جار التحميل…'],
    ['loading…','جار التحميل…'],
    ['loading orders','جار تحميل الطلبات…'],
    ['loading orders...','جار تحميل الطلبات…'],
    ['loading orders…','جار تحميل الطلبات…'],
    ['loading addresses','جار تحميل العناوين…'],
    ['loading addresses...','جار تحميل العناوين…'],
    ['loading addresses…','جار تحميل العناوين…'],
    ['loading address','جار تحميل العنوان…'],
    ['loading address...','جار تحميل العنوان…'],
    ['loading address…','جار تحميل العنوان…'],
    ['loading profile','جار تحميل معلومات الحساب…'],
    ['loading profile...','جار تحميل معلومات الحساب…'],
    ['loading profile…','جار تحميل معلومات الحساب…'],
    ['loading account','جار تحميل الحساب…'],
    ['loading account...','جار تحميل الحساب…'],
    ['loading account…','جار تحميل الحساب…'],
    ['loading data','جار تحميل البيانات…'],
    ['loading data...','جار تحميل البيانات…'],
    ['loading data…','جار تحميل البيانات…'],
    ['saving','جار الحفظ…'],
    ['saving...','جار الحفظ…'],
    ['saving…','جار الحفظ…'],
    ['updating','جار التحديث…'],
    ['updating...','جار التحديث…'],
    ['updating…','جار التحديث…']
  ];

  const loadingArToEn=new Map(
    loadingPairs.map(([en,ar])=>[normalize(ar),en.includes('...')||en.includes('…')?en:'Loading...'])
  );

  function localizeDynamicStatus(raw,arabic){
    const key=normalize(raw);
    if(!key) return null;

    if(arabic){
      const pair=loadingPairs.find(([en])=>normalize(en)===key);
      if(pair) return pair[1];

      const generic=key.match(/^loading(?:\s+.+)?(?:\.\.\.|…)?$/i);
      if(generic) return 'جار التحميل…';
      return null;
    }

    if(loadingArToEn.has(key)){
      const english=loadingArToEn.get(key);
      if(key.includes('الطلبات')) return 'Loading orders...';
      if(key.includes('العناوين')) return 'Loading addresses...';
      if(key.includes('العنوان')) return 'Loading address...';
      if(key.includes('الحساب')) return 'Loading account...';
      if(key.includes('البيانات')) return 'Loading data...';
      if(key.includes('الحفظ')) return 'Saving...';
      if(key.includes('التحديث')) return 'Updating...';
      return english;
    }

    return null;
  }

  function textOf(element){
    return String(element?.innerText||element?.textContent||'').replace(/\s+/g,' ').trim();
  }

  function closestInteractive(element){
    return element?.closest?.('button,a,[role="tab"],[role="button"]')||null;
  }

  function findInteractive(scope,keys){
    const wanted=new Set(keys.map(normalize));
    const excluded='[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-account-v14-footer],[data-nmr-address-engine],[data-nmr-account-app-boot]';

    const valid=element=>
      element
      && !element.closest(excluded)
      && !element.closest('form,label')
      && wanted.has(normalize(textOf(element)));

    const primary=[...scope.querySelectorAll(
      'button,a,[role="tab"],[role="button"],[tabindex]:not([tabindex="-1"]),summary'
    )].find(valid);

    if(primary) return primary;

    const structural=[...scope.querySelectorAll(
      '[class*="tab"],[class*="Tab"],[class*="nav"],[class*="Nav"],[class*="menu"],[class*="Menu"],[data-tab],[data-value]'
    )]
      .filter(valid)
      .sort((a,b)=>a.querySelectorAll('*').length-b.querySelectorAll('*').length);

    if(structural[0]) return structural[0];

    const loose=[...scope.querySelectorAll('span,div,p,li,strong,small')]
      .filter(valid)
      .sort((a,b)=>{
        const children=a.querySelectorAll('*').length-b.querySelectorAll('*').length;
        if(children!==0) return children;
        return a.textContent.length-b.textContent.length;
      });

    return loose[0]||null;
  }

  function commonAncestor(elements,stop){
    if(elements.length<2) return elements[0]?.parentElement||null;
    let node=elements[0].parentElement;
    while(node&&node!==stop){
      if(elements.every(element=>node.contains(element))) return node;
      node=node.parentElement;
    }
    return null;
  }

  function translateScope(scope){
    const arabic=isArabic();
    const walker=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT);
    const nodes=[];
    let node;

    while((node=walker.nextNode())) nodes.push(node);

    nodes.forEach(item=>{
      const raw=item.nodeValue||'';
      const key=normalize(raw);
      if(!key) return;

      const parent=item.parentElement;
      if(!parent||parent.closest('script,style,[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-address-engine],[data-nmr-account-v14-footer],[data-nmr-account-app-boot]')) return;

      if(roleMap.has(key)){
        (parent.closest('label,h1,h2,h3,h4,p,span,strong,div')||parent)
          .setAttribute('data-nmr-account-role',roleMap.get(key));
      }

      const statusHost=parent.closest('p,small,li,span')||parent;
      statusHost.removeAttribute('data-nmr-account-native-loading');

      const dynamic=localizeDynamicStatus(raw,arabic);
      if(dynamic){
        const leading=raw.match(/^\s*/)?.[0]||'';
        const trailing=raw.match(/\s*$/)?.[0]||'';
        item.nodeValue=leading+dynamic+trailing;
        statusHost.setAttribute('data-nmr-account-native-loading','true');
        return;
      }

      if(arabic&&translations.has(key)){
        const leading=raw.match(/^\s*/)?.[0]||'';
        const trailing=raw.match(/\s*$/)?.[0]||'';
        item.nodeValue=leading+translations.get(key)+trailing;
      }
    });

    scope.querySelectorAll('[placeholder],[aria-label],[title]').forEach(element=>{
      ['placeholder','aria-label','title'].forEach(attribute=>{
        const raw=element.getAttribute(attribute);
        const key=normalize(raw);
        if(!key) return;

        const dynamic=localizeDynamicStatus(raw,arabic);
        if(dynamic){
          element.setAttribute(attribute,dynamic);
          return;
        }

        if(arabic&&translations.has(key)){
          element.setAttribute(attribute,translations.get(key));
        }
      });
    });

    scope.querySelectorAll('input[type="button"][value],input[type="submit"][value]').forEach(element=>{
      const raw=element.value;
      const key=normalize(raw);
      const dynamic=localizeDynamicStatus(raw,arabic);

      if(dynamic){
        element.value=dynamic;
        return;
      }

      if(arabic&&translations.has(key)){
        element.value=translations.get(key);
      }
    });
  }

  function emailFrom(scope){
    const text=textOf(scope);
    const match=text.match(/[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/i);
    return match?.[0]||'';
  }

  function nativeTabs(scope){
    return tabDefs.map(def=>({
      ...def,
      native:findInteractive(scope,def.keys)
    }));
  }

  function detectedNativeTabId(items,scope){
    const headings=headingCandidates(scope).map(element=>normalize(textOf(element)));
    const visibleText=headings.join(' | ');

    if(
      visibleText.includes('my orders')
      || visibleText.includes('orders')
      || visibleText.includes('order history')
      || visibleText.includes('no orders yet')
      || visibleText.includes('طلباتي')
      || visibleText.includes('الطلبات')
      || visibleText.includes('سجل الطلبات')
      || visibleText.includes('لا توجد طلبات')
    ) return 'orders';

    if(
      visibleText.includes('addresses')
      || visibleText.includes('my addresses')
      || visibleText.includes('add address')
      || visibleText.includes('العناوين')
      || visibleText.includes('عناويني')
      || visibleText.includes('إضافة عنوان')
    ) return 'addresses';

    if(
      visibleText.includes('profile details')
      || visibleText.includes('basic information')
      || visibleText.includes('بيانات الملف الشخصي')
      || visibleText.includes('المعلومات الأساسية')
      || visibleText.includes('my information')
      || visibleText.includes('معلوماتي')
    ) return 'profile';

    const explicit=items.find(item=>{
      const element=item.native;
      if(!element) return false;
      return element.getAttribute('aria-selected')==='true'
        || element.getAttribute('aria-current')==='page'
        || element.classList.contains('active')
        || element.dataset.active==='true';
    });

    return explicit?.id||items[0]?.id||'profile';
  }

  function activeTabId(items,scope){
    const desired=scope?.dataset?.nmrAccountUiTab;
    if(desired&&items.some(item=>item.id===desired)) return desired;
    return detectedNativeTabId(items,scope);
  }

  

  function hideNativeIdentity(scope,logout,email){
    if(!logout) return;

    const candidates=[...scope.querySelectorAll('div,section,header,article,li')];
    const matching=candidates
      .filter(element=>
        element!==scope
        && element.contains(logout)
        && /@/.test(textOf(element))
      )
      .sort((a,b)=>a.querySelectorAll('*').length-b.querySelectorAll('*').length);

    let target=matching[0]||null;

    if(!target){
      let candidate=logout.parentElement;
      let depth=0;

      while(candidate&&candidate!==scope&&depth<5){
        const text=textOf(candidate);
        if(
          candidate.querySelectorAll('button,a,[role="button"]').length>=1
          && text.length>0
          && text.length<320
        ){
          target=candidate;
        }

        if(/@/.test(text)) break;

        candidate=candidate.parentElement;
        depth+=1;
      }
    }

    if(target){
      target.setAttribute('data-nmr-account-native-v10-hidden','identity');

      const sibling=target.nextElementSibling;
      if(
        sibling
        && (
          sibling.tagName==='HR'
          || (
            textOf(sibling)===''
            && sibling.querySelectorAll('button,a,input,select,textarea').length===0
          )
        )
      ){
        sibling.setAttribute('data-nmr-account-native-v10-hidden','identity-separator');
      }
    }
  }

  function hideNativeTabs(scope,items){
    const elements=items.map(item=>item.native).filter(Boolean);
    if(elements.length<2) return;

    const host=commonAncestor(elements,scope);
    if(host&&host!==scope){
      host.setAttribute('data-nmr-account-native-v10-hidden','tabs');
    }
  }

  function findNativeEdit(scope){
    return findInteractive(scope,['edit','تعديل']);
  }

  function findNativeLogout(scope){
    return findInteractive(scope,['log out','logout','تسجيل الخروج']);
  }

  function fieldKey(field){
    return {
      name:field?.getAttribute('name')||'',
      autocomplete:field?.getAttribute('autocomplete')||'',
      type:field?.getAttribute('type')||'',
      aria:field?.getAttribute('aria-label')||''
    };
  }

  function findFieldByKey(scope,key){
    const fields=[...scope.querySelectorAll('input,select,textarea')]
      .filter(element=>!element.closest('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head]'));

    return fields.find(element=>
      (key.name&&element.getAttribute('name')===key.name)
      || (key.autocomplete&&element.getAttribute('autocomplete')===key.autocomplete)
      || (key.aria&&element.getAttribute('aria-label')===key.aria)
    )||null;
  }

  function activateNativeEdit(scope,focusKey){
    const nativeEdit=findNativeEdit(scope);
    if(!nativeEdit) return false;

    const label=normalize(textOf(nativeEdit));
    if(label!=='edit'&&label!=='تعديل') return false;

    nativeEdit.click();

    if(focusKey){
      window.setTimeout(()=>{
        const next=findFieldByKey(scope,focusKey);
        if(next&&!next.disabled&&!next.readOnly){
          next.focus({preventScroll:true});
        }
      },80);
    }

    return true;
  }

  function visibleElement(element){
    if(!element||element.hidden||element.getAttribute('aria-hidden')==='true') return false;
    const style=window.getComputedStyle(element);
    return style.display!=='none'&&style.visibility!=='hidden';
  }

  function fieldLabel(scope,field){
    const direct=field.closest('label');
    if(direct) return direct;

    const id=field.id;
    if(id){
      try{
        return scope.querySelector('label[for="'+CSS.escape(id)+'"]');
      }catch(e){
        void e;
      }
    }

    return null;
  }

  function addressFieldKind(scope,field){
    const label=fieldLabel(scope,field);
    const signature=normalize([
      field.getAttribute('name')||'',
      field.id||'',
      field.getAttribute('autocomplete')||'',
      field.getAttribute('placeholder')||'',
      field.getAttribute('aria-label')||'',
      textOf(label)
    ].join(' '));

    if(!signature) return null;
    if(/email|e-mail/.test(signature)) return null;
    if(/company|organization/.test(signature)) return 'company';
    if(/first.?name|given.?name/.test(signature)) return 'first_name';
    if(/last.?name|family.?name/.test(signature)) return 'last_name';
    if(/phone|tel/.test(signature)) return 'phone';
    if(/address[-_ ]?2|address line 2|apartment|suite|unit/.test(signature)) return 'address2';
    if(/address[-_ ]?1|address line 1|street address|street|address1/.test(signature)) return 'address1';
    if(/country/.test(signature)) return 'country';
    if(/postal|postcode|zip/.test(signature)) return 'postal';
    if(/province|state|region/.test(signature)) return 'province';
    if(/city|locality|town/.test(signature)) return 'city';
    if(/\baddress\b/.test(signature)) return 'address1';
    return null;
  }

  

  function setAutocomplete(field,kind){
    const map={
      first_name:'given-name',
      last_name:'family-name',
      phone:'tel',
      address1:'address-line1',
      address2:'address-line2',
      country:'country-name',
      city:'address-level2',
      province:'address-level1',
      postal:'postal-code'
    };

    if(map[kind]){
      field.setAttribute('autocomplete',map[kind]);
    }

    if(kind==='postal'){
      field.setAttribute('inputmode','text');
    }
  }

  function searchKey(value){
    return normalize(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g,'');
  }

  function ensureCountryEngine(select,label){
    if(!(select instanceof HTMLSelectElement)||select.options.length<2||!label) return;

    let host=label.querySelector('[data-nmr-address-engine]');
    if(!host){
      host=document.createElement('div');
      host.className='nmr-address-engine';
      host.setAttribute('data-nmr-address-engine','true');

      const input=document.createElement('input');
      input.type='search';
      input.className='nmr-address-engine__search';
      input.setAttribute('data-nmr-address-country-search','true');
      input.setAttribute('role','combobox');
      input.setAttribute('aria-autocomplete','list');
      input.setAttribute('aria-expanded','false');
      input.setAttribute('autocomplete','off');

      const list=document.createElement('div');
      list.className='nmr-address-engine__list';
      list.setAttribute('data-nmr-address-country-list','true');
      list.setAttribute('role','listbox');
      list.hidden=true;

      host.append(input,list);
      select.insertAdjacentElement('beforebegin',host);
      select.setAttribute('data-nmr-address-country-native','true');

      const render=()=>{
        const query=searchKey(input.value);
        const options=[...select.options]
          .filter(option=>option.value&&option.textContent.trim())
          .map(option=>({
            value:option.value,
            label:option.textContent.trim(),
            key:searchKey(option.textContent)
          }))
          .filter(option=>!query||option.key.includes(query))
          .slice(0,10);

        list.innerHTML='';

        options.forEach(option=>{
          const button=document.createElement('button');
          button.type='button';
          button.className='nmr-address-engine__option';
          button.setAttribute('role','option');
          button.textContent=option.label;
          button.addEventListener('pointerdown',event=>{
            event.preventDefault();
            select.value=option.value;
            input.value=option.label;
            list.hidden=true;
            input.setAttribute('aria-expanded','false');
            select.dispatchEvent(new Event('input',{bubbles:true}));
            select.dispatchEvent(new Event('change',{bubbles:true}));
          });
          list.append(button);
        });

        list.hidden=options.length===0;
        input.setAttribute('aria-expanded',list.hidden?'false':'true');
      };

      input.addEventListener('focus',render);
      input.addEventListener('input',render);
      input.addEventListener('keydown',event=>{
        if(event.key==='Escape'){
          list.hidden=true;
          input.setAttribute('aria-expanded','false');
        }
      });

      host.addEventListener('focusout',()=>{
        window.setTimeout(()=>{
          if(!host.contains(document.activeElement)){
            list.hidden=true;
            input.setAttribute('aria-expanded','false');
          }
        },0);
      });

      select.addEventListener('change',()=>{
        const selected=select.options[select.selectedIndex];
        if(selected){
          input.value=selected.textContent.trim();
        }
      });
    }

    const input=host.querySelector('[data-nmr-address-country-search]');
    if(input){
      const selected=select.options[select.selectedIndex];
      const current=selected?.textContent?.trim()||'';
      if(document.activeElement!==input&&input.value!==current){
        input.value=current;
      }
      input.disabled=select.disabled;
      input.readOnly=select.readOnly;
      input.placeholder=isArabic()?'ابحث عن الدولة':'Search country';
      input.setAttribute('aria-label',input.placeholder);
    }
  }

  function enhanceAddressForm(scope,active){
    const fields=[...scope.querySelectorAll('input,select,textarea')]
      .filter(field=>
        !field.closest('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-address-engine]')
        && visibleElement(field)
      );

    fields.forEach(field=>{
      const kind=addressFieldKind(scope,field);
      if(!kind) return;

      field.setAttribute('data-nmr-address-control',kind);
      setAutocomplete(field,kind);

      const label=fieldLabel(scope,field);
      if(label){
        label.setAttribute('data-nmr-address-field',kind);
      }

      if(kind==='country'&&field instanceof HTMLSelectElement){
        ensureCountryEngine(field,label);
      }
    });

    if(active==='addresses') compactAddressFields(scope);
  }

  function markNativeActions(scope){
    const arabic=isArabic();

    [...scope.querySelectorAll('button,input[type="button"],input[type="submit"],a[role="button"]')]
      .filter(element=>!element.closest('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-account-v14-footer],[data-nmr-address-engine]'))
      .forEach(element=>{
        const raw=element instanceof HTMLInputElement?element.value:textOf(element);
        const key=normalize(raw);
        let action=null;

        if(['save','save changes','update','update changes','حفظ','حفظ التغييرات','تحديث','تحديث التغييرات'].includes(key)) action='save';
        else if(['cancel','discard','discard changes','إلغاء','إلغاء التغييرات'].includes(key)) action='cancel';

        if(!action) return;

        element.setAttribute('data-nmr-account-native-action',action);
        const label=action==='save'
          ?(arabic?'حفظ التغييرات':'Save changes')
          :(arabic?'إلغاء':'Cancel');

        if(element instanceof HTMLInputElement) element.value=label;
        else element.textContent=label;
      });
  }

  function syncPendingState(scope){
    scope.querySelector('[data-nmr-account-v15-pending]')?.remove();
    delete scope.dataset.nmrAccountPendingTab;
  }


  function fieldSignature(scope,field){
    const label=fieldLabel(scope,field);
    return normalize([
      field.getAttribute('name')||'',
      field.id||'',
      field.getAttribute('autocomplete')||'',
      field.getAttribute('placeholder')||'',
      field.getAttribute('aria-label')||'',
      textOf(label)
    ].join(' '));
  }

  function profileDefault(scope,kind){
    const regex={
      first_name:/first.?name|given.?name|الاسم الأول/,
      last_name:/last.?name|family.?name|اسم العائلة/,
      phone:/phone|tel|رقم الهاتف/
    }[kind];

    if(!regex) return '';

    const matches=[...scope.querySelectorAll('input,textarea')]
      .filter(field=>regex.test(fieldSignature(scope,field))&&field.value.trim());

    return (matches.find(field=>!visibleElement(field))||matches[0])?.value?.trim()||'';
  }

  function compactAddressFields(scope){
    [...scope.querySelectorAll('[data-nmr-address-control]')].forEach(field=>{
      const kind=field.getAttribute('data-nmr-address-control');
      const label=fieldLabel(scope,field);
      if(!label) return;

      const hide=()=>label.setAttribute('data-nmr-address-hidden','true');
      const show=()=>label.removeAttribute('data-nmr-address-hidden');

      if(kind==='company'){hide();return;}

      if(kind==='phone'){
        if(!field.value.trim()){
          const value=profileDefault(scope,'phone');
          if(value){
            field.value=value;
            field.dispatchEvent(new Event('input',{bubbles:true}));
            field.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
        hide();
        return;
      }

      if(kind==='first_name'||kind==='last_name'){
        if(!field.value.trim()){
          const value=profileDefault(scope,kind);
          if(value){
            field.value=value;
            field.dispatchEvent(new Event('input',{bubbles:true}));
            field.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
        if(field.required&&!field.value.trim()) show();
        else hide();
        return;
      }

      if(kind==='province'){
        if(field.required) show();
        else hide();
        return;
      }

      show();
    });
  }

  function ensureProfileFooter(scope,active){
    let footer=scope.querySelector('[data-nmr-account-v14-footer]');
    if(!footer){
      footer=document.createElement('div');
      footer.className='nmr-account-v14__footer';
      footer.setAttribute('data-nmr-account-v14-footer','true');

      const button=document.createElement('button');
      button.type='button';
      button.className='nmr-account-v14__logout';
      button.setAttribute('data-nmr-account-v14-logout','true');
      button.addEventListener('click',()=>{
        findNativeLogout(scope)?.click();
      });

      footer.append(button);
      scope.append(footer);
    }

    const button=footer.querySelector('[data-nmr-account-v14-logout]');
    footer.hidden=active!=='addresses';

    if(button){
      button.textContent=isArabic()?'تسجيل الخروج':'Log out';
      button.hidden=!findNativeLogout(scope);
    }

    if(active==='addresses'&&footer!==scope.lastElementChild){
      scope.append(footer);
    }
  }

  function headingCandidates(scope){
    return [...scope.querySelectorAll('h1,h2,h3,h4')]
      .filter(element=>{
        if(
          element.closest('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head]')
          || element.hasAttribute('data-nmr-account-native-v10-hidden')
          || element.closest('[data-nmr-account-native-v10-hidden]')
          || element.hidden
          || element.getAttribute('aria-hidden')==='true'
        ){
          return false;
        }

        const style=window.getComputedStyle(element);
        return style.display!=='none'&&style.visibility!=='hidden';
      });
  }

  function currentHeading(scope){
    return headingCandidates(scope).find(element=>textOf(element))||null;
  }

  function currentSubtitle(title){
    if(!title) return null;
    const parent=title.parentElement;
    if(!parent) return null;

    const direct=[...parent.children].find(element=>
      element!==title
      && element.matches('p,small,span')
      && textOf(element)
    );
    return direct||null;
  }

  function buildHeader(scope){
    const arabic=isArabic();
    const email=emailFrom(scope);
    const logout=findNativeLogout(scope);
    const tabs=nativeTabs(scope);
    const active=activeTabId(tabs,scope);

    hideNativeIdentity(scope,logout,email);
    hideNativeTabs(scope,tabs);

    let header=scope.querySelector('[data-nmr-account-v10-header]');
    if(!header){
      header=document.createElement('div');
      header.className='nmr-account-v10__shell-head';
      header.setAttribute('data-nmr-account-v10-header','true');

      const nav=document.createElement('div');
      nav.className='nmr-account-v10__tabs';
      nav.setAttribute('data-nmr-account-v13-tabs','true');
      header.append(nav);
      scope.prepend(header);
    }

    header.dataset.activeTab=active;
    const nav=header.querySelector('[data-nmr-account-v13-tabs]');
    if(!nav) return;

    nav.style.setProperty('--nmr-a10-tab-count',String(tabs.length||3));

    tabs.forEach(item=>{
      let button=nav.querySelector('[data-nmr-account-v10-tab="'+item.id+'"]');

      if(!button){
        button=document.createElement('button');
        button.type='button';
        button.className='nmr-account-v10__tab';
        button.dataset.nmrAccountV10Tab=item.id;

        button.addEventListener('click',()=>{
          const wanted=button.dataset.nmrAccountV10Tab;

          const commit=()=>{
            scope.dataset.nmrAccountUiTab=wanted;
            buildHeader(scope);
            buildContentHead(scope);
          };

          const activate=()=>{
            const native=nativeTabs(scope).find(entry=>entry.id===wanted)?.native;
            if(!native) return false;

            native.click();
            commit();
            return true;
          };

          if(activate()) return;

          let tries=0;
          const retry=()=>{
            tries+=1;

            if(activate()) return;

            if(tries>=12){
              const current=detectedNativeTabId(nativeTabs(scope),scope);
              scope.dataset.nmrAccountUiTab=current;
              buildHeader(scope);
              buildContentHead(scope);
              return;
            }

            window.setTimeout(retry,55);
          };

          window.setTimeout(retry,35);
        });

        nav.append(button);
      }

      const nextLabel=arabic?item.ar:item.en;
      if(button.textContent!==nextLabel) button.textContent=nextLabel;

      if(item.id===active) button.setAttribute('aria-current','page');
      else button.removeAttribute('aria-current');
    });
  }

  

  function buildContentHead(scope){
    const arabic=isArabic();
    const nativeEdit=findNativeEdit(scope);
    const logout=findNativeLogout(scope);
    const tabs=nativeTabs(scope);
    const active=activeTabId(tabs,scope);
    const title=currentHeading(scope);
    const subtitle=currentSubtitle(title);

    if(title) title.setAttribute('data-nmr-account-native-v10-hidden','title');
    if(subtitle) subtitle.setAttribute('data-nmr-account-native-v10-hidden','subtitle');
    if(nativeEdit) nativeEdit.setAttribute('data-nmr-account-native-v10-hidden','edit');

    const labels={
      profile:{
        arTitle:'معلوماتي',
        enTitle:'My information',
        arSub:'بيانات حسابك ومعلومات التواصل',
        enSub:'Your account details and contact information'
      },
      orders:{
        arTitle:'طلباتي',
        enTitle:'My orders',
        arSub:'متابعة الطلبات السابقة والحالية',
        enSub:'Track your current and previous orders'
      },
      addresses:{
        arTitle:'العناوين',
        enTitle:'Addresses',
        arSub:'إدارة عناوين الحساب',
        enSub:'Manage your saved addresses'
      }
    };

    const copy=labels[active]||labels.profile;

    let head=scope.querySelector('[data-nmr-account-v10-content-head]');
    if(!head){
      head=document.createElement('div');
      head.className='nmr-account-v10__content-head';
      head.setAttribute('data-nmr-account-v10-content-head','true');

      const heading=document.createElement('div');
      heading.className='nmr-account-v10__heading';

      const h=document.createElement('h2');
      h.className='nmr-account-v10__title';
      h.setAttribute('data-nmr-account-v13-title','true');

      const p=document.createElement('p');
      p.className='nmr-account-v10__subtitle';
      p.setAttribute('data-nmr-account-v13-subtitle','true');

      heading.append(h,p);

      const actions=document.createElement('div');
      actions.className='nmr-account-v10__content-actions';
      actions.setAttribute('data-nmr-account-v13-actions','true');

      const edit=document.createElement('button');
      edit.type='button';
      edit.className='nmr-account-v10__edit';
      edit.setAttribute('data-nmr-account-v13-edit','true');
      edit.addEventListener('click',()=>{
        activateNativeEdit(scope);
      });

      const logoutProxy=document.createElement('button');
      logoutProxy.type='button';
      logoutProxy.className='nmr-account-v10__logout';
      logoutProxy.setAttribute('data-nmr-account-v13-logout','true');
      logoutProxy.addEventListener('click',()=>{
        findNativeLogout(scope)?.click();
      });

      actions.append(edit,logoutProxy);
      head.append(heading,actions);

      const header=scope.querySelector('[data-nmr-account-v10-header]');
      if(header){
        header.insertAdjacentElement('afterend',head);
      }else{
        scope.prepend(head);
      }
    }

    const h=head.querySelector('[data-nmr-account-v13-title]');
    const p=head.querySelector('[data-nmr-account-v13-subtitle]');
    const actions=head.querySelector('[data-nmr-account-v13-actions]');
    const edit=head.querySelector('[data-nmr-account-v13-edit]');
    const logoutProxy=head.querySelector('[data-nmr-account-v13-logout]');

    const nextTitle=arabic?copy.arTitle:copy.enTitle;
    const nextSubtitle=arabic?copy.arSub:copy.enSub;

    if(h&&h.textContent!==nextTitle) h.textContent=nextTitle;
    if(p&&p.textContent!==nextSubtitle) p.textContent=nextSubtitle;

    const showActions=active==='profile';
    if(actions) actions.hidden=!showActions||!nativeEdit;

    if(edit){
      edit.hidden=!showActions||!nativeEdit;
      edit.textContent=arabic?'تعديل':'Edit';
    }

    if(logoutProxy){
      logoutProxy.hidden=true;
    }
  }

  function rootVisible(){
    const current=root();
    if(!current||current.hidden||current.getAttribute('aria-hidden')==='true') return false;

    const panel=current.querySelector('.otp-account-modal');
    if(!panel) return false;

    const style=window.getComputedStyle(panel);
    const rect=panel.getBoundingClientRect();

    return style.display!=='none'
      && style.visibility!=='hidden'
      && Number.parseFloat(style.opacity||'1')>0
      && rect.width>0
      && rect.height>0;
  }

  function accountIdentity(){
    return String(
      window.OTP_PLUS_CUSTOMER?.customer_id
      || document.body?.dataset?.nmrCustomerId
      || 'session'
    );
  }

  function warmKey(){
    return 'nmr-account-warm-v'+WARM_VERSION+':'+accountIdentity();
  }

  function isWarm(){
    try{
      return sessionStorage.getItem(warmKey())==='1';
    }catch(e){
      return false;
    }
  }

  function markWarm(){
    try{
      sessionStorage.setItem(warmKey(),'1');
    }catch(e){
      void e;
    }
  }

  function nativeLoading(scope){
    const walker=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT);
    let node;

    while((node=walker.nextNode())){
      const parent=node.parentElement;
      if(!parent) continue;

      if(parent.closest('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-account-v14-footer],[data-nmr-address-engine],[data-nmr-account-app-boot]')){
        continue;
      }

      const key=normalize(node.nodeValue||'');
      if(
        key.startsWith('loading')
        || key.includes('جار التحميل')
        || key.includes('جار تحميل')
      ){
        return true;
      }
    }

    return false;
  }

  function explicitNativeTab(scope){
    const items=nativeTabs(scope);
    const explicit=items.find(item=>{
      const element=item.native;
      if(!element) return false;
      return element.getAttribute('aria-selected')==='true'
        || element.getAttribute('aria-current')==='page'
        || element.classList.contains('active')
        || element.dataset.active==='true';
    });
    return explicit?.id||null;
  }

  function wait(ms){
    return new Promise(resolve=>window.setTimeout(resolve,ms));
  }

  async function waitForDashboard(timeout=2600){
    const started=performance.now();

    while(performance.now()-started<timeout){
      const scope=dashboard();
      if(scope) return scope;
      await wait(40);
    }

    return null;
  }

  async function waitForNativeTab(scope,id,timeout=1350){
    const started=performance.now();

    while(performance.now()-started<timeout){
      if(explicitNativeTab(scope)===id&&!nativeLoading(scope)){
        return true;
      }
      await wait(45);
    }

    return explicitNativeTab(scope)===id;
  }

  function ensureAppBoot(scope){
    let boot=scope.querySelector('[data-nmr-account-app-boot]');
    if(!boot){
      boot=document.createElement('div');
      boot.className='nmr-account-v16__boot';
      boot.setAttribute('data-nmr-account-app-boot','true');
      boot.hidden=true;

      const card=document.createElement('div');
      card.className='nmr-account-v16__boot-card';

      const mark=document.createElement('span');
      mark.className='nmr-account-v16__boot-mark';

      const title=document.createElement('strong');
      title.setAttribute('data-nmr-account-app-boot-title','true');

      const line1=document.createElement('span');
      line1.className='nmr-account-v16__skeleton nmr-account-v16__skeleton--wide';

      const line2=document.createElement('span');
      line2.className='nmr-account-v16__skeleton nmr-account-v16__skeleton--mid';

      const line3=document.createElement('span');
      line3.className='nmr-account-v16__skeleton nmr-account-v16__skeleton--short';

      card.append(mark,title,line1,line2,line3);
      boot.append(card);
      scope.append(boot);
    }

    const title=boot.querySelector('[data-nmr-account-app-boot-title]');
    if(title){
      title.textContent=isArabic()?'جاري تجهيز حسابك…':'Preparing your account…';
    }

    return boot;
  }

  function prewarmAccountShell(reason){
    try{
      window.NMRAccountPlatform?.prepare?.();
    }catch(e){
      void e;
    }

    try{
      window.NMRAccountV10?.init?.();
    }catch(e){
      void e;
    }

    try{
      document.dispatchEvent(
        new CustomEvent('nmr:warmup:account-secondary',{
          detail:{reason:'v16-'+reason}
        })
      );
    }catch(e){
      void e;
    }
  }

  async function warmDashboard(reason,{visibleBoot=false}={}){
    if(isWarm()) return true;
    if(warmPromise) return warmPromise;
    if(warmAttempts>=3) return false;

    warmAttempts+=1;

    warmPromise=(async()=>{
      const scope=await waitForDashboard(2800);
      if(!scope) return false;

      const visible=rootVisible();
      if(visible&&!visibleBoot) return false;

      const tabs=nativeTabs(scope);
      if(tabs.length<2) return false;

      const boot=visibleBoot?ensureAppBoot(scope):null;
      if(boot) boot.hidden=false;

      const previousUi=scope.dataset.nmrAccountUiTab||'profile';
      scope.dataset.nmrAccountUiTab='profile';
      buildHeader(scope);
      buildContentHead(scope);

      const sequence=['orders','addresses'].filter(id=>tabs.some(item=>item.id===id));

      for(const id of sequence){
        const item=nativeTabs(scope).find(entry=>entry.id===id);
        if(!item?.native) continue;
        item.native.click();
        await waitForNativeTab(scope,id,1500);
      }

      const profile=nativeTabs(scope).find(entry=>entry.id==='profile');
      if(profile?.native){
        profile.native.click();
        await waitForNativeTab(scope,'profile',1200);
      }

      scope.dataset.nmrAccountUiTab=previousUi==='addresses'||previousUi==='orders'
        ? previousUi
        : 'profile';

      if(boot) boot.hidden=true;

      markWarm();
      schedule();
      return true;
    })().finally(()=>{
      warmPromise=null;
    });

    return warmPromise;
  }

  function warmOnIdle(){
    const customerLoggedIn=Boolean(
      window.OTP_PLUS_CUSTOMER?.logged_in
      || window.OTP_PLUS_CUSTOMER?.customer_id
      || document.body?.dataset?.nmrCustomerId
    );

    if(!customerLoggedIn||isWarm()) return;

    const runWarm=()=>{
      if(rootVisible()) return;
      void warmDashboard('idle');
    };

    if('requestIdleCallback' in window){
      window.requestIdleCallback(runWarm,{timeout:1800});
    }else{
      window.setTimeout(runWarm,900);
    }
  }

  function decorate(){
    const scope=dashboard();
    if(!scope) return;

    scope.setAttribute('data-nmr-account-dashboard-v10','true');
    scope.setAttribute('data-nmr-account-dashboard-v18','true');
    scope.setAttribute('dir',isArabic()?'rtl':'ltr');

    translateScope(scope);

    if(!scope.dataset.nmrAccountUiTab){
      scope.dataset.nmrAccountUiTab=detectedNativeTabId(nativeTabs(scope),scope);
    }

    buildHeader(scope);
    buildContentHead(scope);

    const currentActive=activeTabId(nativeTabs(scope),scope);
    enhanceAddressForm(scope,currentActive);
    ensureProfileFooter(scope,currentActive);
    markNativeActions(scope);
    syncPendingState(scope);

    if(!scope.dataset.nmrAccountV15FieldBridge){
      scope.dataset.nmrAccountV15FieldBridge='true';

      scope.addEventListener('pointerdown',event=>{
        const label=event.target.closest?.('label');
        if(!label||label.closest('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head]')) return;

        const locked=label.querySelector('input:disabled,input[readonly],select:disabled,textarea:disabled,textarea[readonly]');
        if(!locked) return;

        event.preventDefault();
        activateNativeEdit(scope,fieldKey(locked));
      });
    }
  }



  function run(){
    frame=0;
    if(dashboard()){
      decorate();
    }
  }

  function schedule(){
    if(frame) return;
    frame=window.requestAnimationFrame(run);
  }


  function managedNode(node){
    if(!node) return false;

    const element=
      node.nodeType===Node.ELEMENT_NODE
        ? node
        : node.parentElement;

    if(!element) return false;

    return Boolean(
      element.matches?.('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-address-engine],[data-nmr-account-v14-footer],[data-nmr-account-app-boot]')
      || element.closest?.('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-address-engine],[data-nmr-account-v14-footer],[data-nmr-account-app-boot]')
    );
  }

  const observer=new MutationObserver(records=>{
    const scope=dashboard();
    if(!scope) return;

    const relevant=records.some(record=>{
      const target=
        record.target.nodeType===Node.ELEMENT_NODE
          ? record.target
          : record.target.parentElement;

      if(
        target
        && target.closest?.('[data-nmr-account-v10-header],[data-nmr-account-v10-content-head],[data-nmr-address-engine],[data-nmr-account-v14-footer],[data-nmr-account-app-boot]')
      ){
        return false;
      }

      if(record.type==='characterData'){
        return Boolean(target&&scope.contains(target));
      }

      const changed=[
        ...record.addedNodes,
        ...record.removedNodes
      ];

      if(changed.length&&changed.every(managedNode)){
        return false;
      }

      return Boolean(
        (target&&scope.contains(target))
        || changed.some(node=>
          node.nodeType===Node.ELEMENT_NODE
          && (
            scope.contains(node)
            || node.contains?.(scope)
          )
        )
      );
    });

    if(relevant){
      schedule();
    }
  });

  observer.observe(document.documentElement,{
    childList:true,
    subtree:true,
    characterData:true,
    attributes:true,
    attributeFilter:['disabled','readonly','hidden','aria-hidden','class']
  });



  function accountTriggerFromEvent(event){
    const path=typeof event.composedPath==='function'?event.composedPath():[];
    return path.find(node=>node instanceof Element&&node.matches?.(ACCOUNT_TRIGGER_SELECTOR))
      || event.target?.closest?.(ACCOUNT_TRIGGER_SELECTOR)
      || null;
  }

  function onAccountPreAction(event){
    if(!accountTriggerFromEvent(event)) return;
    prewarmAccountShell(event.type);
  }

  document.addEventListener('pointerdown',onAccountPreAction,true);
  document.addEventListener('touchstart',onAccountPreAction,{capture:true,passive:true});

  window.addEventListener('nmr:account-open',()=>{
    prewarmAccountShell('open');
    schedule();
  });

  window.addEventListener('otp-plus-nca-login',()=>{
    prewarmAccountShell('login');

    window.setTimeout(async()=>{
      const scope=await waitForDashboard(2600);
      if(!scope) return;

      scope.dataset.nmrAccountUiTab='profile';
      schedule();

      if(rootVisible()){
        void warmDashboard('post-login',{visibleBoot:true});
      }
    },80);
  });

  window.addEventListener('nmr:account-close',()=>{
    window.setTimeout(()=>{
      if(!rootVisible()){
        void warmDashboard('after-close');
      }
    },60);
  });

  window.addEventListener('pageshow',warmOnIdle);
  window.addEventListener('load',warmOnIdle,{once:true});

  function syncInteractionState(){
    const current=root();
    if(!current) return;

    const hidden=
      current.hidden
      || current.getAttribute('aria-hidden')==='true';

    current.style.pointerEvents=hidden?'none':'auto';

    if(hidden) return;

    const interactive=current.querySelectorAll(
      '.otp-account-modal-backdrop,.otp-account-modal,.otp-account-dashboard,button,a,input,select,textarea,label,[role="button"],[role="tab"],[tabindex]'
    );

    interactive.forEach(element=>{
      if(
        element.matches('input:disabled,select:disabled,textarea:disabled')
        || element.hasAttribute('data-nmr-account-native-v10-hidden')
        || element.closest('[data-nmr-account-native-v10-hidden]')
      ){
        return;
      }

      element.style.pointerEvents='auto';
    });
  }

  window.addEventListener('nmr:account-open',syncInteractionState);
  window.addEventListener('otp-plus-nca-login',()=>{
    window.setTimeout(syncInteractionState,0);
  });

  const interactionObserver=new MutationObserver(syncInteractionState);
  interactionObserver.observe(document.documentElement,{
    subtree:true,
    childList:true,
    attributes:true,
    attributeFilter:['hidden','aria-hidden','class']
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',schedule,{once:true});
  }else{
    schedule();
  }
})();
